import React from 'react';
import { string, shape, arrayOf, bool, number, func } from 'prop-types';

import { BrandDownloadCard } from 'components/cards';
import { getLocalization } from '../utils';

const DocumentsListing = ({ groups, handleShowAllClick, configName }) => {
    if (!groups || !groups.length) {
        return null;
    }

    return (
        <React.Fragment>
            {groups.map(
                ({
                    title,
                    id,
                    itemsAmount,
                    items,
                    showAll,
                    filterId,
                    filterOptionId
                }) => (
                    <div className="c-listing__documents-block" key={id}>
                        {title && (
                            <h2 className="c-listing__documents-title h4">
                                {title}
                                <span className="results-amount">
                                    ({itemsAmount})
                                </span>
                            </h2>
                        )}
                        <div className="grid grid--cards grid--equal-height">
                            {!!items &&
                                !!items.length &&
                                items.map(item => (
                                    <div className="col-md-4" key={item.id}>
                                        <BrandDownloadCard {...item} />
                                    </div>
                                ))}
                        </div>
                        {showAll && (
                            <div className="c-listing__documents-block-button">
                                <button
                                    className="link"
                                    type="button"
                                    onClick={() =>
                                        handleShowAllClick(
                                            filterId,
                                            filterOptionId
                                        )
                                    }
                                >
                                    {getLocalization(
                                        configName,
                                        'button/showAll'
                                    )}
                                </button>
                            </div>
                        )}
                    </div>
                )
            )}
        </React.Fragment>
    );
};

DocumentsListing.propTypes = {
    groups: arrayOf(
        shape({
            id: string,
            title: string,
            category: string,
            itemAmount: number,
            showAll: bool,
            items: arrayOf(
                shape({
                    blocked: bool,
                    url: string.isRequired,
                    title: string.isRequired,
                    size: string.isRequired,
                    blockedTitle: string,
                    downloadTitle: string
                })
            )
        })
    ).isRequired,
    configName: string.isRequired,
    handleShowAllClick: func.isRequired
};

export default DocumentsListing;
